export default __webpack_public_path__ + "static/media/plus.icon.b3f08b01.svg";